import React, { useEffect } from "react";

import { useNavigate } from "../../../components/Navigate";
import MainLayout from "../../../components/layout/MainLayout";
import ScreenWrapper from "../../../components/layout/screenWrapper";
import {
  tdoeReportsRegistry,
  TDOE_CHART_TYPES,
} from "../components/reports/tdoeReportsRegistry";

import "../reportsMgmt.scss";

const getReportUrl = (report) => {
  let url;
  switch (report.chartType) {
    case TDOE_CHART_TYPES.PIE:
      url = "/report/tdoe-pie-chart";
      break;
    case TDOE_CHART_TYPES.BAR:
      url = "/report/tdoe-bar-chart";
      break;
    case TDOE_CHART_TYPES.STACKED_BAR:
      url = "/report/tdoe-stacked-bar-chart";
      break;
    case TDOE_CHART_TYPES.CLUSTER_BAR:
      url = "/report/tdoe-cluster-bar-chart";
      break;
    default:
      url = "/report/tdoe-bar-chart";
  }

  const params = new URLSearchParams();
  params.set("title", report.title);

  if (report.chartType === TDOE_CHART_TYPES.CLUSTER_BAR) {
    params.set("gradeLevel", report.gradeLevel);
    params.set("coreAction", report.coreAction);
  } else {
    params.set("qstf", report.questionSurveyTemplateFieldId);
    if (report.defaultGroupBy) {
      params.set("groupBy", report.defaultGroupBy);
    }
  }

  return `${url}?${params.toString()}`;
};

const DataDashboardReportsMgmt = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const screen = window.document.getElementsByClassName("screen");
    if (screen.length > 0) {
      screen[0].scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  const handleReportClick = (report) => {
    navigate(getReportUrl(report), { state: "VISITED" });
  };

  return (
    <>
      <MainLayout>
        <ScreenWrapper loading={false} loadingError={false} onReturn={() => {}}>
          <div className="reports">
            <div className="categoryWrapper reports-title">
              <h1>Data Dashboard Reports</h1>
            </div>
            <div className="contentDisplay">
              {tdoeReportsRegistry.map((report, index) => (
                <div className="categoryWrapper" key={index}>
                  {report.hasDefinition ? (
                    <h3
                      className="categoryTitle report report-title"
                      onClick={() => handleReportClick(report)}
                    >
                      {report.title}
                    </h3>
                  ) : (
                    <h3 className="categoryTitle report report-title no-link">
                      {report.title}
                      <span className="coming-soon-badge">Coming soon</span>
                    </h3>
                  )}
                  <h4 className="report-description">
                    {report.hasDefinition
                      ? "Click to view the TDOE report."
                      : "This report is not yet available."}
                  </h4>
                </div>
              ))}
            </div>
          </div>
        </ScreenWrapper>
      </MainLayout>
    </>
  );
};

export default DataDashboardReportsMgmt;
